import QuickCompaign from "@/modules/Campaign/QuickCampaign";
import routes from "@/routes";
import { lazy } from "react";
import LineItemRoutes from "./lineItem.routes";
const ListCampaign = lazy(
  () => import("@/modules/Campaign/QuickCampaign/ListCampaign")
);
const CreateQuickCampaign = lazy(
  () => import("@/modules/Campaign/QuickCampaign/CreateQuickCampaign")
);
const EditQuickCampaign = lazy(
  () => import("@/modules/Campaign/QuickCampaign/EditQuickCampaign")
);

const QuickCampaignRoutes = {
  element: <QuickCompaign />,
  path: routes.CAMPAIGNS.QUICK_CAMPAIGN.INDEX,

  children: [
    {
      element: <ListCampaign />,
      path: "",
    },
    {
      element: <CreateQuickCampaign />,
      path: routes.CAMPAIGNS.QUICK_CAMPAIGN.CREATE,
    },
    {
      element: <EditQuickCampaign />,
      path: routes.CAMPAIGNS.QUICK_CAMPAIGN.EDIT(),
    },
    LineItemRoutes,
  ],
};

export default QuickCampaignRoutes;
